import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconV2 } from "../../../icon_v2";
export const StatValue = ({ value, secondaryValue, indicator, className = "", }) => {
    const getIndicatorColor = () => {
        switch (indicator === null || indicator === void 0 ? void 0 : indicator.type) {
            case "up":
                return "text-green-600 dark:text-green-500";
            case "down":
                return "text-red-600 dark:text-red-500";
            default:
                return "text-gray-600 dark:text-gray-400";
        }
    };
    const getIndicatorSymbol = () => {
        switch (indicator === null || indicator === void 0 ? void 0 : indicator.type) {
            case "up":
                return (_jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "arrow-right"],
                        fixedWidth: true,
                        size: "lg",
                    } }));
            case "down":
                return (_jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "arrow-right"],
                        fixedWidth: true,
                        size: "lg",
                    } }));
            default:
                return _jsx(_Fragment, {});
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `flex items-baseline gap-1 ${className}`, children: [_jsx("span", { className: "text-2xl font-semibold text-gray-900 dark:text-white", children: value }), secondaryValue !== undefined && (_jsxs(_Fragment, { children: [_jsx("span", { className: "text-2xl text-gray-600 dark:text-gray-400", children: "\u2192" }), _jsx("span", { className: "text-2xl text-gray-600 dark:text-gray-400", children: secondaryValue })] }))] }), indicator && (_jsxs("div", { className: `flex flex-row items-baseline gap-1`, children: [getIndicatorSymbol(), _jsx("span", { className: ` text-2xl ${getIndicatorColor()}`, children: indicator.value })] }))] }));
};
export default StatValue;
